module.exports = __webpack_public_path__ + "static/img/zjwls.59e0156d.png";